var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBatteryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 35,
    viewBox: "0 0 19 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 12.25H3.16667V5.25H15.8333V12.25ZM14.25 1.75C14.25 1.28587 14.0832 0.840752 13.7863 0.512562C13.4893 0.184372 13.0866 0 12.6667 0H6.33333C5.91341 0 5.51068 0.184372 5.21375 0.512562C4.91681 0.840752 4.75 1.28587 4.75 1.75H3.16667C2.32681 1.75 1.52136 2.11875 0.927496 2.77513C0.33363 3.4315 0 4.32174 0 5.25L0 31.5C0 32.4283 0.33363 33.3185 0.927496 33.9749C1.52136 34.6313 2.32681 35 3.16667 35H15.8333C16.6732 35 17.4786 34.6313 18.0725 33.9749C18.6664 33.3185 19 32.4283 19 31.5L19 5.25C19 4.32174 18.6664 3.4315 18.0725 2.77513C17.4786 2.11875 16.6732 1.75 15.8333 1.75H14.25Z",
    fill: "#20E89C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryIcon);
export default __webpack_public_path__ + "static/media/batteryIcon.5298e63ebc363d30b8483b8c5823fe40.svg";
export { ForwardRef as ReactComponent };